import { ReviewProduct } from 'lib/reviews/types';
import { SliderWrapper } from '../SliderWrapper';
import { useTheme } from 'lib/context/ThemeContext';
import { ReviewsListTheme } from './ReviewsList.theme';
import ReviewProductImage from '../ReviewProductImage/ReviewProductImage';
import { Fragment } from 'react';
import { createUUID } from 'lib/utils/string-utils';

interface RenderReviewImageSliderProps {
  slidesData: ReviewProduct[];
  sliderSettings: { [key: string]: unknown };
}

const RenderReviewImageSlider: React.FC<RenderReviewImageSliderProps> = ({
  slidesData,
  sliderSettings,
}) => {
  const { themeData } = useTheme(ReviewsListTheme);

  const formatProductName = (productName: string) => {
    switch (productName) {
      case 'a-series_contemporary':
      case 'a-series_traditional':
        return 'A-Series';
      case '200':
        return '200-Series';
      case '400_sliding':
      case '400_hinged':
        return '400-Series';
      default:
        return productName.replace('_', ' ') || '';
    }
  };

  if (!Array.isArray(slidesData)) {
    console.error('slidesData is not an array: ', slidesData);
    return <></>;
  }

  return (
    <SliderWrapper sliderSettings={sliderSettings}>
      {slidesData?.map((_product: ReviewProduct) => {
        const formattedProductName = formatProductName(_product?.productName);
        const originalProductNameLower = _product?.productName?.toLowerCase();
        return (
          <Fragment key={createUUID()}>
            <div className={themeData.classes.productSectionImageWrapper}>
              <ReviewProductImage productName={originalProductNameLower} />
              <div className={themeData.classes.productSectionProductName}>
                {formattedProductName}
              </div>
            </div>
          </Fragment>
        );
      })}
    </SliderWrapper>
  );
};

export default RenderReviewImageSlider;
